var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.search)?_c('cv-text-input',_vm._g(_vm._b({staticClass:"ff-input"},'cv-text-input',_vm.$attrs,false),_vm.inputListeners)):_c('cv-search',_vm._g(_vm._b({staticClass:"ff-input"},'cv-search',_vm.$attrs,false),_vm.inputListeners))}
var staticRenderFns = []

export { render, staticRenderFns }